import React, {PureComponent} from "react"

import {ReportingTeamState} from "@irati/types"
import theme from "@irati/ui/src/global/theme"

const MAX_X_AXIS_LENGTH = 1140
const MAX_DURATION_IN_SECONDS = 4

interface Props {
  cx: number
  cy: number
  enabledUsers: number
  teamNames?: string[]
  median: number
  lowerMedian: number
  upperMedian: number
}

class CustomizedShape extends PureComponent<Props> {
  getFill = () => {
    const {enabledUsers, median, lowerMedian, upperMedian} = this.props

    if (enabledUsers < lowerMedian) {
      return theme.colors.tertiary.b_50
    }
    if (enabledUsers < median) {
      return theme.colors.tertiary.b_200
    }
    if (enabledUsers < upperMedian) {
      return theme.colors.tertiary.b_300
    }
    return theme.colors.tertiary.b_400
  }

  getDuration = () => {
    const xPositionConvertedIntoDuration = MAX_X_AXIS_LENGTH / MAX_DURATION_IN_SECONDS
    const {cx} = this.props
    return `${cx / xPositionConvertedIntoDuration}s`
  }

  render() {
    const {cx, cy, teamNames, teamState} = this.props
    const fill = teamNames ? theme.colors.tertiary.b_50 : this.getFill()

    if (teamState === ReportingTeamState.BillingUnit) {
      return (
        <svg id="adminSection_teamEngagementGraphTriangle" x={cx} y={cy}>
          <path d="M10 0L20 20H0L10 0Z" fill={theme.colors.tertiary.y_400} />
        </svg>
      )
    }

    return (
      <>
        <circle id="adminSection_teamEngagementGraphBubble" cx={cx} cy={cy} r={10} fill={fill}>
          <animate attributeName="r" from="0" to="10" dur={this.getDuration()} />
        </circle>
        {teamNames && teamNames.length > 1 && (
          <text textAnchor="middle" x={cx} y={cy + 5} stroke={theme.colors.utility.ink}>
            {teamNames.length}
          </text>
        )}
      </>
    )
  }
}

export default CustomizedShape
